// extracted by mini-css-extract-plugin
module.exports = {"pageBtn":"pageitem_pageBtn__2Z2Mp","xs":"pageitem_xs__11s7T"};